(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-product-hero"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ps-hero]').forEach(function (hero) {
    // Gallery
    var slides = hero.querySelectorAll('[data-ps-slide]');
    var thumbs = hero.querySelectorAll('[data-ps-thumb]');
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var i = thumb.getAttribute('data-ps-thumb');
        slides.forEach(function (s) { s.classList.toggle('is-active', s.getAttribute('data-ps-slide') === i); });
        thumbs.forEach(function (t) { t.classList.toggle('is-active', t === thumb); });
      });
    });

    // Bundle selected state
    var rows = hero.querySelectorAll('.ps-bundle__row');
    hero.querySelectorAll('input[name="id"]').forEach(function (input) {
      input.addEventListener('change', function () {
        rows.forEach(function (r) { r.classList.toggle('is-selected', r.contains(input)); });
      });
    });

    // Add to cart (progressive enhancement — falls back to native form post)
    var form = hero.querySelector('[data-ps-form]');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return; // native submit
      e.preventDefault();
      var btn = form.querySelector('.ps-atc');
      if (btn) btn.classList.add('is-loading');
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function () {
          // Try common theme cart-drawer hooks; fall back to cart page.
          var opened = false;
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true }));
            var drawer = document.querySelector('cart-drawer, #CartDrawer, .drawer--cart, [data-cart-drawer]');
            if (drawer) {
              if (typeof drawer.open === 'function') { drawer.open(); opened = true; }
              else { drawer.classList.add('active', 'is-open', 'drawer--is-open'); opened = true; }
            }
          } catch (err) {}
          if (!opened) window.location.href = '/cart';
          if (btn) btn.classList.remove('is-loading');
        })
        .catch(function () { form.submit(); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ps-sticky-atc"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.querySelectorAll('[data-ps-sticky]').forEach(function (bar) {
    var form = bar.querySelector('[data-ps-sticky-form]');
    var idInput = bar.querySelector('[data-ps-sticky-id]');
    var priceEl = bar.querySelector('[data-ps-sticky-price]');
    // Sync with hero bundle selection
    function syncFromHero() {
      var checked = document.querySelector('[data-ps-hero] input[name="id"]:checked');
      if (checked && idInput) {
        idInput.value = checked.value;
        if (priceEl && checked.getAttribute('data-price')) priceEl.textContent = checked.getAttribute('data-price');
      }
    }
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id' && e.target.closest('[data-ps-hero]')) syncFromHero();
    });
    syncFromHero();
    if (!form) return;
    form.addEventListener('submit', function (e) {
      if (!window.fetch) return;
      e.preventDefault();
      syncFromHero();
      var data = new FormData(form);
      fetch('/cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: data })
        .then(function (r) { return r.json(); })
        .then(function () {
          var opened = false;
          try {
            document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
            var drawer = document.querySelector('cart-drawer, #CartDrawer, .drawer--cart, [data-cart-drawer]');
            if (drawer) { if (typeof drawer.open === 'function') { drawer.open(); opened = true; } else { drawer.classList.add('active','is-open','drawer--is-open'); opened = true; } }
          } catch (err) {}
          if (!opened) window.location.href = '/cart';
        })
        .catch(function () { form.submit(); });
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
